import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DataListingProviderComponent } from 'src/app/shared/components/data-listing-provider/data-listing-provider.component';
import { AuthenticationGuard } from '../../../shared/guard/authentication-guard';
import { HasUnsavedChangesGuard } from '../../../shared/guard/has-form-changed.guard';
import { ModuleId } from '../../../shared/store/navigation/types';
import { Entity, HeaderMenuType } from '../../../shared/store/view/types';
import { ProductLineCreateComponent } from './product-line-create/product-line-create.component';
import { ProductLineDetailsComponent } from './product-line-details/product-line-details.component';
import { ProductLineEditComponent } from './product-line-edit/product-line-edit.component';

const routes: Routes = [
  {
    path: 'Insurance/ProductLines',
    data: {
      breadcrumb: { label: ' ', alias: 'list' },
    },
    children: [
      {
        path: '',
        redirectTo: 'List',
        pathMatch: 'full',
      },
      {
        path: 'List',
        component: DataListingProviderComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Insurance,
          moduleId: ModuleId.insurance,
          entity: Entity.ProductLine,
          breadcrumb: { skip: true },
        },
      },
      {
        path: 'Details/:id',
        component: ProductLineDetailsComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Insurance,
          moduleId: ModuleId.insurance,
          entity: Entity.ProductLine,
          breadcrumb: { label: ' ', alias: 'productLineDetails' },
        },
      },
      {
        path: 'Create',
        component: ProductLineCreateComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Insurance,
          moduleId: ModuleId.insurance,
          entity: Entity.ProductLine,
          breadcrumb: { label: ' ', alias: 'productLineCreate' },
        },
      },
      {
        path: 'Edit/:id',
        component: ProductLineEditComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Insurance,
          moduleId: ModuleId.insurance,
          entity: Entity.ProductLine,
          breadcrumb: { label: ' ', alias: 'productLineEdit' },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductLineRoutingModule {}
